import { BaseModel } from './common'

export const KITS_API_KEY_MAX_KEYS = 3

export interface KitsApiKey extends BaseModel {
  aiUserId: number
  prefix: string
  key: string
}
